module.exports = __webpack_public_path__ + "a225211715e8886f9469f6fbf244bf3b.svg";